import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';
import { connect } from 'react-redux';

class AutoCompleteDataContainer extends React.Component {
    state = {
        choices: [],
    }

    componentDidUpdate(prevProps) {
        const { data } = this.props;

        if (prevProps.data !== data) {
            this.setState({
                choices: data,
            });
        }
    }

    fetchData = (params) => {
        const { action, dispatchAction, offset, size, sort } = this.props;

        params = params || {};

        const defaultParams = {
            field: sort.field,
            offset: offset,
            order: sort.order,
            size: size,
        };

        /**
         * This will trigger a specific action, which is defined in the upper level.
         * This action can only be a function, and will always pass the id of the record.
         */
        dispatchAction(action(Object.assign({}, defaultParams, params)));
    }

    handleUpdateInput = utils.debounce((searchText, dataSource, params, keyName) => {
        const { minLength } = this.props;

        // If the string of the source is not 'change' it will not continue.
        if (params.source !== 'change') {
            return;
        }

        // Remove whitespaces around the text.
        if (utils.isString(searchText)) {
            searchText = `*${ searchText.trim() }*`;
        }

        // Remove whitespaces around the text.
        if (searchText.length < minLength) {
            return this.setState({
                choices: [],
            });
        }

        // Check if the searchText already exists in the dataSource.
        const textExists = dataSource.filter(function (data) {
            return data.text === searchText;
        });

        // If the length of the array > 0, it will not continue.
        if (textExists.length) {
            return;
        }

        this.fetchData({
            [keyName]: searchText,
        });
    }, this.props.debounceTime);

    render() {
        const {
            children,
            optionalFilter,
            reference,
            size,
            style,
        } = this.props;

        const {
            choices,
        } = this.state;

        let results = choices;

        if (!utils.isEmpty(optionalFilter)) {
            utils.each(optionalFilter, function (value, key) {
                results = results.filter(function (result) {
                    return result[key] === value;
                });
            });
        }

        return (
            <div style={ style }>
                { React.cloneElement(children, {
                    choices: results,
                    resource: reference,
                    size: size,
                    setFilter: this.handleUpdateInput,
                }) }
            </div>
        );
    }
}

AutoCompleteDataContainer.defaultProps = {
    debounceTime: 500,
    minLength: 3,
    optionalFilter: {},
    offset: 0,
    size: 12,
    sort: {
        field: 'id',
        order: 'asc',
    },
    style: {},
};

AutoCompleteDataContainer.propTypes = {
    action: PropTypes.func,
    children: PropTypes.element,
    debounceTime: PropTypes.number,
    data: PropTypes.array,
    dispatchAction: PropTypes.func,
    minLength: PropTypes.number,
    optionalFilter: PropTypes.object,
    offset: PropTypes.number,
    reference: PropTypes.string,
    size: PropTypes.number,
    sort: PropTypes.shape({
        field: PropTypes.string,
        order: PropTypes.string,
    }).isRequired,
    style: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const { reference } = props;
    const stateResource = state[reference];

    function objectToArray(data) {
        if (utils.isEmpty(data)) {
            return [];
        }

        const result = Object.keys(data).map(function (key) {
            return data[key];
        });

        return result;
    }

    return {
        data: objectToArray(stateResource.data),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAction: (action) => {
            dispatch(action);
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AutoCompleteDataContainer);



// WEBPACK FOOTER //
// ./src/containers/Data/AutoCompleteDataContainer.js